import FilePreviewModal from './FilePreviewModal';
import './FilePreviewModal.scss';

export default FilePreviewModal;
